import { render, staticRenderFns } from "./ModalUpdateReservation.vue?vue&type=template&id=58538ed8&scoped=true&"
import script from "./ModalUpdateReservation.vue?vue&type=script&lang=ts&"
export * from "./ModalUpdateReservation.vue?vue&type=script&lang=ts&"
import style0 from "./ModalUpdateReservation.vue?vue&type=style&index=0&id=58538ed8&lang=scss&scoped=true&"
import style1 from "./ModalUpdateReservation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58538ed8",
  null
  
)

export default component.exports